








import { Vue, Component, Watch } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import BottomTabbar from './components/BottomTabbar.vue';
import { getBaseinfo } from '@/api/api';
import * as config from './config';

@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  option = config.OPTHINES;
  baseInfo: any = {};
  source: any = null;
  @Watch('$route', {
    immediate: true,
  })
  onRouteChange(to: any) {
    if (to.path === '/20200401GYGG/List/2') {
      this.source = 2;
    }
    if (to.path === '/20200401GYGG/List?dataSource=2') {
      this.source = 2;
    }
  }
  created() {
    getBaseinfo(this.option.voteName).then((res) => (this.baseInfo = res.data));
    this.$addPv(this.baseInfo.activityId);
  }
}
